<article
  [attr.role]="role"
  [attr.tabIndex]="tabIndex"
  (click)="goToActivityDetail(activity.sku)"
  class="live-card flex lg:min-h-live-card"
>
  <div class="live-card__start" [attr.datetime]="activity.duration">
    <time class="live-card__start__hour" [attr.datetime]="timeslot.startDate">
      {{ startHour }}
    </time>
  </div>

  <img
    [src]="picture"
    *ngIf="!isMobileDevice"
    alt=""
    loading="lazy"
    class="live-card__image hidden self-center object-cover lg:ml-4 lg:block"
  />

  <div class="px-4 pt-3 pb-2">
    <p class="text-black text-sm font-medium">
      {{ sportsName }}
    </p>

    <p *ngIf="organizationName" class="text-grey-dark-1 text-sm font-medium">
      {{ organizationName }}
    </p>

    <h3 class="my-2 lg:mt-0 text-black font-bold">
      {{ activity.name }}
    </h3>

    <app-vtmn-rating
      *ngIf="reviewsStats?.count > 0"
      class="flex mt-2 mb-2"
      [compact]="true"
      [showValue]="true"
      [value]="reviewsStats?.averageRating"
      [comments]="
        'activity.reviews.count-reviews'
          | translate: { reviewQuantity: reviewsStats?.count?.toString() }
      "
      [size]="ratingSizeEnum.SMALL"
      [emphasis]="true"
    ></app-vtmn-rating>

    <div class="flex flex-wrap">
      <app-badge *ngIf="hasDuration" class="mr-2 mb-2" [variant]="badgeVariant">
        {{ formattedDuration }}
      </app-badge>

      <app-badge *ngIf="hasAgeRange" class="mr-2 mb-2" [variant]="badgeVariant">
        {{ activity.typicalAgeRange | displayAgeRange }}
      </app-badge>

      <app-badge *ngIf="hasLevel" class="mr-2 mb-2" [variant]="badgeVariant">
        {{ activity.proficiencyLevel | displayLevel }}
      </app-badge>

      <app-badge *ngIf="hasPrice" class="mb-2" [variant]="priceBadgeVariant">
        {{
          activity.startingPrice?.amount
            | displayPrice
              : activity.startingPrice?.currency
              : activity.highestPrice?.amount
        }}
      </app-badge>


    </div>
  </div>

  <a
    *ngIf="!isMobileDevice"
    class="my-auto ml-auto mr-4"
    app-vtmn-play-button
    [routerLink]="['/attendee.show-live-activity', activity.sku] | localize"
  >
    {{ 'attendee.live_card.button.label' | translate }}
  </a>
</article>
